<template>
  <div class="homeBox">
    <div class="topbanner" :style="'background-image:url('+banner+')'">
      <div class="z1200 topbanner_tip">
        <a class="imgbox" href="/home">
          <img :src="logo" alt="">
        </a>
        <div class="logoname">
          用户通行证
        </div>
        <div class="topNav">
          <a href="http://www.pengzushijia.com" class="span_nav" target="_blank">平台导航</a>
          <a :href="getTokenUrl" class="span_nav" target="_blank" @click="handeGo">编纂平台</a>
          <a href="http://maker.pengzushijia.com/project/allDataBase" class="span_nav" target="_blank">总数据库</a>
          <!--<a href="http://admin.pengzushijia.com" class="span_nav" target="_blank">管理平台</a>-->
          <a href="http://i.pengzushijia.com/home" target="_blank" class="span_nav" style="font-weight: bold;font-size: 16px;margin-left: 10px;width: 113px;">彭祖世家网首页</a>
        </div>
        <!--<div class="topTip">-->
        <!--<p class="p1">-->
        <!--<svg-icon icon-class="home_passcard" />-->
        <!--</p>-->
        <!--<p class="p2">-->
        <!--主页-->
        <!--</p>-->
        <!--</div>-->
        <!--<span class="gohome" @click="backBtn">-->
        <!--<svg-icon icon-class="home" />-->
        <!--回到主页</span>-->
        <!--<div class="outBtn" @click="outlogin">-->
        <!--退出-->
        <!--</div>-->
      </div>
    </div>
    <ul class="topnav z1200">
      <li :class="currentIndex==0?'active':'notive'" @click="changeIndex(0)">
        通行证首页
      </li>
      <li :class="currentIndex==1?'active':'notive'" @click="changeIndex(1)">
        我的钱包
      </li>
      <li :class="currentIndex==2?'active':'notive'" @click="changeIndex(2)">
        我的积分
      </li>
      <!--<li :class="currentIndex==3?'active':'notive'" @click="changeIndex(3)">-->
        <!--我的关注-->
      <!--</li>-->
      <li :class="currentIndex==4?'active':'notive'" @click="changeIndex(4)">
        我的收藏
      </li>
      <!--<li :class="currentIndex==5?'active':'notive'" @click="changeIndex(-1)">-->
        <!--我的消息-->
      <!--</li>-->
      <!--<li :class="currentIndex==6?'active':'notive'" @click="changeIndex(6)">-->
        <!--推广中心-->
      <!--</li>-->
      <li :class="currentIndex==7?'active':'notive'" @click="changeIndex(7)">
        我的评论
      </li>
    </ul>
    <div v-if="currentIndex==0" class="contentShow">
      <passcardhome />
    </div>
    <div v-if="currentIndex==1" class="contentShow">
      <mymoney />
    </div>
    <div v-if="currentIndex==2" class="contentShow">
      <myIntegral />
    </div>
    <!--<div v-if="currentIndex==3" class="contentShow">-->
      <!--<myFollow />-->
    <!--</div>-->
    <div v-if="currentIndex==4" class="contentShow z1200">
      <mycollect />
    </div>
    <!--<div v-if="currentIndex==6" class="contentShow z1200">-->
      <!--<myPromotion />-->
    <!--</div>-->
    <div v-if="currentIndex==7" class="contentShow z1200">
      <mycoponent />
    </div>
    <Footer />
  </div>
</template>
<script>
import passcardhome from '@/components/passcardNav/passcardhome.vue'
import mymoney from '@/components/passcardNav/mymoney.vue'
import myIntegral from '@/components/passcardNav/myIntegral.vue'
import myFollow from '@/components/passcardNav/myFollow.vue'
import mycollect from '@/components/passcardNav/mycollect.vue'
import mycoponent from '@/components/passcardNav/mycoponent.vue'
import myPromotion from '@/components/passcardNav/myPromotion.vue'

import Footer from '@/components/passcardNav/footer.vue'

import { userOutLogin, loadIndex } from '@/api/api.js'
import { ssoUserLogin } from '@/api/api.js'
import { addLoginState } from '@/api/login.js'
export default {
  components: { passcardhome, Footer, mymoney, myIntegral, myFollow, mycollect, mycoponent, myPromotion },
  data() {
    return {
      getTokenUrl: '',
      puyueCode: require('@/static/readerCode.png'),
      fmsCode: require('@/static/familyspaceCode.png'),
      currentIndex: 0,
      userID: '',
      banner: require('@/static/passcodebanner.png'),
      logo: require('@/static/logo_gengji2.png')
    }
  },
  head() {
    // var listObj = this.$store.state.hotList_home
    var metaStr = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: '',
      mateDesc: metaStr
    }
  },
  watch: {
    $route() {
      this.currentIndex = this.$route.query.index
      ssoUserLogin().then(res => {
        if (res.data.userId) {
          this.setloca('userid', res.data.userId, 7200)
          localStorage.removeItem('unionid')
        } else {
          this.$alert('您的登录信息已经过期，请重新登录', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.push('/login')
            }
          })
          localStorage.removeItem('userid')
        }
      })
    }
  },
  beforeMount() {
    ssoUserLogin().then(res => {
      if (res.data.userId) {
        this.setloca('userid', res.data.userId, 7200)
        localStorage.removeItem('unionid')
      } else {
        this.$alert('您的登录信息已经过期，请重新登录', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.push('/login')
          }
        })
        localStorage.removeItem('userid')
      }
    })
  },
  mounted() {
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which
      if (keycode == 13) {
        return false
      }
    }
    this.handeGo()
    this.currentIndex = this.$route.query.index
  },
  methods: {
    changeIndex: function(index) {
      if (index >= 0) {
        this.currentIndex = index
        this.$router.replace({ path: '/user', query: { index: index }})
      }
    },
    outlogin() {
      localStorage.removeItem('username')
      localStorage.removeItem('userid')
      localStorage.removeItem('passportid')
      localStorage.removeItem('unionid')
      localStorage.removeItem('readerUsrId')
      userOutLogin().then(res => {

      })
      this.$message({
        showClose: true,
        message: '您已成功退出登录',
        type: 'success'
      })
      this.$router.push({ path: '/login' })
    },
    backBtn() {
      this.$router.push({ path: '/home' })
      // this.$router.go(-1)
    },
    handeGo(url) {
      loadIndex().then(res2 => {
        this.setloca('unionid', res2.data.passportUser.unionid, 7200)
        url = 'http://maker.pengzushijia.com/ssoLogin/ssoLogin?token='
        // url = 'http://maker.myfamilybook.cn/ssoLogin/ssoLogin?token='
        if (this.getLoca('unionid')) {
          addLoginState({ unionid: this.getLoca('unionid') }).then(res => {
            if (res.data.errcode === '0') {
              var nurl = url + res.data.token
              this.getTokenUrl = nurl
            }
            if (res.data.errcode == '1') {
              this.$alert('您的登录信息已经过期，请重新登录', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  this.$router.push('/login')
                }
              })
            }
          })
        } else {
          this.$alert('您的登录信息已经过期，请重新登录', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.push('/login')
            }
          })
          localStorage.removeItem('userid')
        }
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .topNav{
    position: absolute;
    top: 65px;
    right: 0;
    height: 40px;
    font-size: 0;
    .span_nav{
      width: 85px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      display: inline-block;
      font-size: 16px;
      color: #fff;
      vertical-align: top;
      &:hover{
        color: #ed4040;
      }
    }
  }
  .puyueCode{
    width: 179px;
    /*height: 213px;*/
    position: absolute;
    top: 26px;
    left: -54px;
    z-index: 99;
    transition: 0.3s;
    height: 0;
  }
  .fmsCode{
    width: 179px;
    /*height: 213px;*/
    position: absolute;
    top: 26px;
    left: -48px;
    z-index: 99;
    transition: 0.3s;
    height: 0;
  }
  .fms:hover >.fmsCode{
    height: 213px;
  }
  .puyue:hover >.puyueCode{
    height: 213px;
  }
    .z1200{
        width: 1200px;
        margin: 0 auto;
    }
    .homeBox{
        background-color: #F3F6FA;
        overflow: hidden;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
        min-height: 100vh;
        .topbanner{
            width: 100%;
            height: 180px;
            background-position: center center;
            background-size: auto 100%;
            .topbanner_tip{
                height: 180px;
                line-height: 180px;
                position: relative;
                .imgbox{
                    width: 223px;
                    height: 72px;
                    display: inline-block;
                    font-size: 0;
                    vertical-align: middle;
                    img{
                        vertical-align: top;
                    }
                }
                .logoname{
                    display: inline-block;
                    height: 72px;
                    line-height: 72px;
                    font-size: 20px;
                    color: #ffffff;
                    margin-left: 25px;
                }
                .topTip{
                    position: absolute;
                    top: 0;
                    right: 0;
                    background-color: #E3003A;
                    width: 48px;
                    height: 68px;
                    p{
                        width: 48px;
                        color: #ffffff;
                        height: 20px;
                        line-height: 20px;
                        font-size: 14px;
                        text-align: center;
                        cursor: pointer;
                    }
                    .p1{
                        margin-top: 12px;
                        svg{
                            vertical-align: top;
                            font-size: 18px;
                        }
                    }
                }
              .outBtn{
                position: absolute;
                top: 80px;
                right: 0;
                width: 48px;
                height: 20px;
                background-color: #fff;
                color: #ed4040;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                cursor: pointer;
              }
              .gohome{
                display: inline-block;
                position: absolute;
                top: 80px;
                right: 60px;
                width: 80px;
                height: 20px;
                background-color: #fff;
                color: #ed4040;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                cursor: pointer;
              }
            }
        }
        .topnav{
            background-color: #2F2935;
            height: 60px;
            margin-top: -30px;
            line-height: 60px;
            font-size: 0;
            position: relative;
            .notive{
                font-size: 16px;
                color: #ffffff;
                padding-bottom: 15px;
                display: inline-block;
                vertical-align: top;
                line-height: 20px;
                border-bottom: 2px solid transparent;
                margin-top: 18px;
                margin-left: 42px;
                margin-right: 42px;
                cursor: pointer;
            }
            .active{
                font-size: 16px;
                color: #ffffff;
                padding-bottom: 15px;
                display: inline-block;
                vertical-align: top;
                line-height: 20px;
                border-bottom: 2px solid #E0466E;
                margin-top: 18px;
                margin-left: 42px;
                margin-right: 42px;
                cursor: pointer;
            }
        }
      .contentShow{
        overflow: hidden;
      }
    }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
    @media screen and (max-width: 750px) {
        .newsBox{
            margin-top: 10px;
            .leftBox{
                display: none;
            }
            .rightBox{
                display: block;
                width: auto;
                margin: 0 10px;
            }
        }
    }
</style>
